import {
  FieldValues,
  Path,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";

// https://github.com/react-hook-form/react-hook-form/issues/4604
export const customRegister = <TFieldValues extends FieldValues>(
  name: string,
  register: UseFormRegister<TFieldValues>,
  options?: RegisterOptions<TFieldValues, Path<TFieldValues>> | undefined
) => {
  const { ref, ...field } = register(name as Path<TFieldValues>, options);

  const customRef = (args: any) => {
    setTimeout(() => ref(args));
  };

  return { ...field, ref: customRef };
};
